import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { signOut } from '@utils/auth';
import { Mutex } from 'async-mutex';
import UserAuth from './auth';

const mutex = new Mutex();

const authQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_AUTH_API_DOMAIN}/${process.env.REACT_APP_API_VERSION}/`
});

const noAuthBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_API_VERSION}/`
  // credentials: 'include'
});

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_API_VERSION}/`,
  prepareHeaders(headers) {
    const token = UserAuth.accessToken;

    if (token) headers.set('Authorization', `Bearer ${token}`);
    // headers.set('Access-Control-Allow-Credentials', 'true');

    return headers;
  }
  // credentials: 'include'
});

const googleSpreadsheetsBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_GOOGLE_SPREADSHEETS_DOMAIN}/`
});

const googleAuthBaseQuery = fetchBaseQuery({
  baseUrl: 'https://oauth2.googleapis.com'
});

const redirectionApiBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_REDIRECT_URL}`
});

const baseQueryWithReauth: any = async (
  args: any,
  api: any,
  extraOptions: any
) => {
  await mutex.waitForUnlock();
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401)
    if (!mutex.isLocked()) {
      const release = await mutex.acquire();

      try {
        const refresh_token = UserAuth.refreshToken;
        const refreshResult: any = await authQuery(
          {
            url: `${process.env.REACT_APP_AUTH_API_DOMAIN}/${process.env.REACT_APP_API_VERSION}/refresh/`,
            method: 'POST',
            body: {
              refresh: refresh_token
            }
          },
          api,
          extraOptions
        );

        if (!refreshResult.error) {
          UserAuth.setAccessToken(refreshResult?.data?.access);

          result = await baseQuery(args, api, extraOptions);
        } else {
          signOut();
        }
      } catch {
        signOut();
      } finally {
        release();
      }
    } else {
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extraOptions);
    }

  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  tagTypes: [
    'projectList',
    'projectFieldList',
    'updateChartConfig',
    'deletedProjectList',
    'commentList',
    'notificationsList',
    'allNotificationsList',
    'chartData',
    'basicChartData'
  ]
});

export const noAuthBaseApi = createApi({
  reducerPath: 'noAuthApi',
  baseQuery: noAuthBaseQuery,
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true
});

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: authQuery,
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true
});

export const googleSpreadsheetsApi = createApi({
  reducerPath: 'googleSpreadsheetsApi',
  baseQuery: googleSpreadsheetsBaseQuery,
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true
});

export const googleAuthApi = createApi({
  reducerPath: 'googleAuthApi',
  baseQuery: googleAuthBaseQuery,
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true
});

export const redirectionApi = createApi({
  reducerPath: 'redirectionApi',
  baseQuery: redirectionApiBaseQuery,
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true
});

export default baseApi;
